import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=0d52312f"
import script from "./ResponsiveImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponsiveImage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports